import gql from 'graphql-tag';

export const GET_VO_TEMPLATES_AND_STAGES = gql`
  query VOTemplatesAndStages($id: ID!) {
    vendorOpportunity(id: $id) {
      businessProcessFlows {
        flows {
          businessProcessFlowId
          currentStage
        }
      }
    }
  }
`;
